"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-Overlay{background-color:" }, { "theme": "whiteTranslucent40", "defaultValue": "rgba(255,255,255,.4)" }, { "rawString": ";position:absolute;bottom:0;left:0;right:0;top:0}.ms-Overlay.ms-Overlay--none{visibility:hidden}.ms-Overlay.ms-Overlay--dark{background-color:" }, { "theme": "blackTranslucent40", "defaultValue": "rgba(0,0,0,.4)" }, { "rawString": "}" }]);
/* tslint:enable */

//# sourceMappingURL=Overlay.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Overlay/Overlay.scss.js
 ** module id = 160
 ** module chunks = 0
 **/